import Home from "./pages/Home";
import Blog from "./pages/Blog";
import DetailBlog from "./pages/DetailBlog";
import NoMatch from "./pages/NoMatch";
import Nav from "./pages/components/Nav";
import Footer from "./pages/components/Footer";
import { Routes, Route } from "react-router-dom";
import styled from "styled-components";
import { CSSTransition, TransitionGroup } from 'react-transition-group';


function App() {
    return (
        <>
            <Nav/>
            <BlockMenu/>
            <Routes>
                <Route path="*" element={<NoMatch />} />
                <Route path="/" element={<Home/>}/>
                <Route path="/blog/" element={<Blog />} />
                <Route path="/blog/:slug" element={<DetailBlog />} />
            </Routes>
            <Footer />
        </>
    );
}
const BlockMenu = styled.div `
  padding-bottom:60px;
`;
export default App;
